@if (priceRange?.min && priceRange?.max) {
{{ priceRange?.min | number: '1.2-2' }} -
{{ priceRange?.max | number: '1.2-2' }}
} @else {
{{ (priceRange?.min | number: '1.2-2') || notAvailable }}
}
